import { apiServer } from 'settings/web-services/api';

export function getSymphonySummary(cfg) {
  return apiServer.get(`/agentTeam/dashboard/summary`);
}

export function getSymphonyList(cfg) {
  return apiServer.get(`/agentTeam/dashboard/members`, { params: cfg });
}

export function getSymphonyStats(cfg) {
  return apiServer.get(`/dashboard/symphony/stats`, { params: cfg });
}

export function getSymphonyPreferences(cfg) {
  return apiServer.get(`/dashboard/symphony/preferences`, { params: cfg });
}

export function updateSymphonyPreferences(cfg) {
  return apiServer.post(`/dashboard/symphony/preferences`, cfg);
}

export function getSymphonyActiveClients(cfg) {
  return apiServer.get(`dashboard/symphony/details/active-clients`, { params: cfg });
}

export function getSymphonyPendingClients(cfg) {
  return apiServer.get(`dashboard/symphony/details/pending-clients`, { params: cfg });
}

export function getSymphonyBuyerClients(cfg) {
  return apiServer.get(`dashboard/symphony/details/buyers`, { params: cfg });
}

export function getSymphonySellerClients(cfg) {
  return apiServer.get(`dashboard/symphony/details/sellers`, { params: cfg });
}

export function getSymphonyRetentionClients(cfg) {
  return apiServer.get(`dashboard/symphony/details/retention-clients`, { params: cfg });
}

export function getSymphonyNonRetentionClients(cfg) {
  return apiServer.get(`dashboard/symphony/details/non-kit-retention-clients`, { params: cfg });
}

export function getSymphonyPendingTourRequests(cfg) {
  return apiServer.get(`dashboard/symphony/details/pending-tour-requests`, { params: cfg });
}

export function getSymphonyOpenOffers(cfg) {
  return apiServer.get(`dashboard/symphony/details/offers`, { params: cfg });
}

export function getSymphonyPendingShowings(cfg) {
  return apiServer.get(`dashboard/symphony/details/pending-showings`, { params: cfg });
}

export function getSymphonyPendingSignatures(cfg) {
  return apiServer.get(`dashboard/symphony/details/pending-signatures`, { params: cfg });
}

export function getSymphonyTransactions(cfg) {
  return apiServer.get(`dashboard/symphony/details/transactions`, { params: cfg });
}
